(function () {
  /* ============================================================
     Maison Thaevia — PDP JavaScript
     ============================================================ */

  /* ---- State ---- */
  const state = {
    shape: null,
    gemColour: null,
    metal: null,
    karat: null,
    size: null,
    carat: null,
    variantId: null,
  };

  /* ---- Variant map (built from Liquid JSON) ---- */
  const variants = JSON.parse(
    document.getElementById('mt-pdp-variants-json')?.textContent || '[]'
  );

  function findVariant(opts) {
    return variants.find((v) =>
      v.options.every((o, i) => {
        const key = Object.keys(opts)[i];
        return !key || o === opts[key];
      })
    );
  }

  /* ---- Price display ---- */
  function updatePrice(variantId) {
    const v = variants.find((x) => x.id === variantId);
    if (!v) return;
    const priceEl = document.getElementById('mt-pdp-price');
    if (priceEl) priceEl.textContent = v.price_formatted;
    const addBtn = document.querySelector('.mt-pdp-add-btn');
    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.dataset.label : 'Sold Out';
    }
    const variantInput = document.getElementById('mt-pdp-variant-id');
    if (variantInput) variantInput.value = variantId;
  }

  /* ---- Gallery ---- */
  function initGallery() {
    const thumbs = document.querySelectorAll('.mt-pdp-thumb');
    const mainImages = document.querySelectorAll('.mt-pdp-main__img');
    const mainEl = document.querySelector('.mt-pdp-main');
    const labelEl = document.querySelector('.mt-pdp-main__label');

    if (!thumbs.length) return;

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('is-active'));
        mainImages.forEach((m) => m.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (mainImages[i]) mainImages[i].classList.add('is-active');
        if (labelEl) labelEl.textContent = thumb.dataset.label || '';
      });
    });

    /* Zoom on mousemove */
    if (mainEl) {
      let zooming = false;

      mainEl.addEventListener('mouseenter', () => {
        zooming = true;
        mainEl.classList.add('is-zoomed');
      });

      mainEl.addEventListener('mouseleave', () => {
        zooming = false;
        mainEl.classList.remove('is-zoomed');
        const layer = mainEl.querySelector('.mt-pdp-main__zoom-layer');
        if (layer) {
          layer.style.transform = 'scale(1)';
          layer.style.transformOrigin = '50% 50%';
        }
      });

      mainEl.addEventListener('mousemove', (e) => {
        if (!zooming) return;
        const layer = mainEl.querySelector('.mt-pdp-main__zoom-layer');
        if (!layer) return;
        const rect = mainEl.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        layer.style.transformOrigin = `${x}% ${y}%`;
        layer.style.transform = 'scale(2)';
      });
    }
  }

  /* ---- Shape selector ---- */
  function initShapes() {
    const btns = document.querySelectorAll('.mt-pdp-shape-btn');
    const input = document.getElementById('mt-prop-shape');
    const label = document.getElementById('mt-shape-selected');

    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        btns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        state.shape = btn.dataset.shape;
        if (input) input.value = state.shape;
        if (label) label.textContent = btn.dataset.shape;
      });
    });

    /* Auto-select first */
    if (btns.length) btns[0].click();
  }

  /* ---- Gem colour dots ---- */
  function initGemColour() {
    const dots = document.querySelectorAll('.mt-pdp-dot[data-gem]');
    const input = document.getElementById('mt-prop-gem');
    const label = document.getElementById('mt-gem-selected');

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        dots.forEach((d) => d.classList.remove('is-active'));
        dot.classList.add('is-active');
        state.gemColour = dot.dataset.gem;
        if (input) input.value = state.gemColour;
        if (label) label.textContent = dot.dataset.gem;
      });
    });

    if (dots.length) dots[0].click();
  }

  /* ---- Metal tone → karat row ---- */
  function initMetal() {
    const toneDots = document.querySelectorAll('.mt-pdp-dot[data-metal]');
    const karatSections = document.querySelectorAll('.mt-pdp-karat-row');
    const karatPills = document.querySelectorAll('.mt-pdp-pill[data-karat]');
    const metalLabel = document.getElementById('mt-metal-selected');

    function selectTone(dot) {
      toneDots.forEach((d) => d.classList.remove('is-active'));
      dot.classList.add('is-active');
      state.metal = dot.dataset.metal;
      state.karat = null;

      /* Show/hide karat row */
      karatSections.forEach((row) => {
        const forMetal = row.dataset.forMetal?.split(',').map((s) => s.trim()) || [];
        row.hidden = !forMetal.includes(state.metal);
      });

      /* Update label */
      if (metalLabel) metalLabel.textContent = dot.dataset.name || dot.dataset.metal;

      /* Auto-select first visible karat pill */
      const visiblePills = [...karatPills].filter(
        (p) => !p.closest('.mt-pdp-karat-row')?.hidden && !p.disabled
      );
      if (visiblePills.length) selectKarat(visiblePills[0]);
    }

    function selectKarat(pill) {
      karatPills.forEach((p) => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      state.karat = pill.dataset.karat;

      /* Match variant */
      const v = matchVariant();
      if (v) updatePrice(v.id);

      /* Update metal label */
      if (metalLabel) {
        const activeTone = document.querySelector('.mt-pdp-dot[data-metal].is-active');
        const toneName = activeTone?.dataset.name || state.metal || '';
        metalLabel.textContent = state.karat === 'Vermeil'
          ? `${toneName} Vermeil`
          : state.karat
          ? `${toneName} ${state.karat}`
          : toneName;
      }
    }

    toneDots.forEach((dot) => dot.addEventListener('click', () => selectTone(dot)));
    karatPills.forEach((pill) => pill.addEventListener('click', () => {
      if (!pill.disabled) selectKarat(pill);
    }));

    if (toneDots.length) selectTone(toneDots[0]);
  }

  /* ---- Size / length pills ---- */
  function initSize() {
    const sizePills = document.querySelectorAll('.mt-pdp-pill[data-size]');
    const sizeLabel = document.getElementById('mt-size-selected');

    sizePills.forEach((pill) => {
      pill.addEventListener('click', () => {
        if (pill.disabled) return;
        sizePills.forEach((p) => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        state.size = pill.dataset.size;
        const input = document.getElementById('mt-prop-size');
        if (input) input.value = state.size;
        if (sizeLabel) sizeLabel.textContent = state.size;

        const v = matchVariant();
        if (v) updatePrice(v.id);
      });
    });

    if (sizePills.length) sizePills[0].click();
  }

  /* ---- Carat selector ---- */
  function initCarat() {
    const pills = document.querySelectorAll('.mt-pdp-pill[data-carat-val]');
    const input = document.getElementById('mt-prop-carat');
    const label = document.getElementById('mt-carat-selected');
    const dimEl = document.getElementById('mt-carat-dim');
    const svgEllipse = document.querySelector('#mt-blueprint-ellipse');

    /* Blueprint dimensions per carat weight (approx round brilliant) */
    const dims = {
      '0.25': { mm: '4.1', rx: 18, ry: 12 },
      '0.50': { mm: '5.1', rx: 22, ry: 14 },
      '0.75': { mm: '5.9', rx: 26, ry: 16 },
      '1.00': { mm: '6.5', rx: 29, ry: 18 },
      '1.50': { mm: '7.3', rx: 33, ry: 21 },
      '2.00': { mm: '8.2', rx: 37, ry: 24 },
      '3.00': { mm: '9.3', rx: 42, ry: 27 },
    };

    function selectCarat(pill) {
      pills.forEach((p) => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      state.carat = pill.dataset.caratVal;
      if (input) input.value = state.carat;
      if (label) label.textContent = `${state.carat} ct`;

      const d = dims[state.carat];
      if (d) {
        if (dimEl) dimEl.innerHTML = `<strong>${state.carat} ct</strong> · approx ${d.mm} mm`;
        if (svgEllipse) {
          svgEllipse.setAttribute('rx', d.rx);
          svgEllipse.setAttribute('ry', d.ry);
        }
      }
    }

    pills.forEach((pill) => pill.addEventListener('click', () => selectCarat(pill)));
    if (pills.length) selectCarat(pills[0]);
  }

  /* ---- Variant matching heuristic ---- */
  function matchVariant() {
    if (!variants.length) return null;

    /* Try exact match on metal + karat option values */
    const target = [state.metal, state.karat].filter(Boolean);
    const match = variants.find((v) =>
      target.every((t) => v.options.some((o) => o === t))
    );
    return match || variants.find((v) => v.available) || variants[0];
  }

  /* ---- Wishlist (UI only) ---- */
  function initWishlist() {
    const btn = document.querySelector('.mt-pdp-wishlist-btn');
    if (!btn) return;
    btn.addEventListener('click', () => {
      btn.classList.toggle('is-saved');
      btn.setAttribute(
        'aria-label',
        btn.classList.contains('is-saved') ? 'Remove from wishlist' : 'Save to wishlist'
      );
    });
  }

  /* ---- Add to Bag: inject line-item property inputs before submit ---- */
  function initAddToBag() {
    const form = document.getElementById('mt-pdp-form');
    if (!form) return;

    form.addEventListener('submit', (e) => {
      /* mt-cart-drawer.js intercepts /cart/add — let it do the AJAX lift.
         We just need to make sure all properties are in the form. */
      setHiddenInput(form, 'properties[Shape]', state.shape || '');
      setHiddenInput(form, 'properties[Stone Colour]', state.gemColour || '');
      setHiddenInput(form, 'properties[Carat Weight]', state.carat ? `${state.carat} ct` : '');
      setHiddenInput(form, 'properties[Size]', state.size || '');
    });
  }

  function setHiddenInput(form, name, value) {
    let el = form.querySelector(`input[name="${name}"]`);
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      form.appendChild(el);
    }
    el.value = value;
  }

  /* ---- Accordion (details/summary) — close siblings ---- */
  function initAccordion() {
    document.querySelectorAll('.mt-pdp-accordion details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        document.querySelectorAll('.mt-pdp-accordion details').forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      });
    });
  }

  /* ---- Boot ---- */
  function init() {
    initGallery();
    initShapes();
    initGemColour();
    initMetal();
    initSize();
    initCarat();
    initWishlist();
    initAddToBag();
    initAccordion();

    /* Set initial price from first available variant */
    const first = matchVariant();
    if (first) updatePrice(first.id);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
